class HBMenu {

    constructor() {

        // Settings

        this.openedClass = 'show-menu';
        this.buttonSelector = '.Header__HB'; // <button id="hb-menu" type="button"></button>

        // Initializing

        this.body = $('body');
        this.$button = $(this.buttonSelector);

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.toggle = this.toggle.bind(this);

        this.$button.on('click', this.toggle);

    }

    toggle() {

        const menuIsOpened = this.body.hasClass(this.openedClass);
        if (menuIsOpened) {
			this.close()
		} else {
			this.open();
		}

    }


    open() {

        this.body.addClass(this.openedClass);

    }

    close() {

        this.body.removeClass(this.openedClass);

    }

}

export default new HBMenu();



// WEBPACK FOOTER //
// ./js/components/HBMenu.js